import SummerwoodSVG from 'components/summerwoodsvg/summerwood-svg';
import { motion } from 'framer-motion';
import { UI } from 'helpers/constants';
import React from 'react';
export type AnimatedRightArrowProps = {
  hovered: boolean;
};

export const AnimatedRightArrow: React.FunctionComponent<AnimatedRightArrowProps> = ({
  hovered,
}) => {
  const real = {
    notHovered: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0,
        ease: UI.EASE_QUINT,
      },
    },
    hovered: {
      opacity: 0,
      x: '+150%',
      transition: {
        duration: 0.9,
        ease: UI.EASE_QUINT,
      },
    },
  };
  const copy = {
    notHovered: {
      opacity: 0,
      x: '-150%',
      transition: {
        duration: 0,
        ease: UI.EASE_QUINT,
      },
    },
    hovered: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.9,
        ease: UI.EASE_QUINT,
      },
    },
  };

  return (
    <>
      <motion.span
        initial="notHovered"
        variants={copy}
        animate={hovered ? 'hovered' : 'notHovered'}
        style={{ width: '20px', position: 'absolute' }}
        exit={{ opacity: 0 }}
      >
        <SummerwoodSVG type="arrowRight" />
      </motion.span>
      <motion.span
        initial="notHovered"
        variants={real}
        animate={hovered ? 'hovered' : 'notHovered'}
        style={{ width: '20px', position: 'absolute' }}
      >
        <SummerwoodSVG type="arrowRight" />
      </motion.span>
    </>
  );
};
